/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { poemGetSaying } from "../../funcs/poemGetSaying.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$poemGetSaying: ToolDefinition = {
  name: "poem-get-saying",
  description: `一言

想在你的应用里每天展示一句不一样的话，给用户一点小小的惊喜吗？这个“一言”接口就是为此而生。

## 功能概述
每次调用，它都会从我们精心收集的、包含数千条诗词、动漫台词、名人名言的语料库中，随机返回一条。你可以用它来做网站首页的Slogan、应用的启动语，或者任何需要灵感点缀的地方。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await poemGetSaying(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
